<template>
  <div>
    <div class="p-box">
      <div v-if="!loading" class="p-box__body">
        <Info>
          <p>{{ $t('pages.companies.management.franchisees.info1') }}</p>
          <p>{{ $t('pages.companies.management.franchisees.info2') }}</p>
        </Info>
        <div v-show="franchisees && franchisees.length !== 0">
          <div class="p-table__content">
            <table>
              <thead>
                <tr>
                  <th><span>{{ $t('models.franchisee.modelName') }}</span></th>
                  <th>
                    <button
                      class="p-table__content__sort"
                      :class="orderCss"
                      @click="sort"
                    >
                      {{ $t('labels.storeCount') }}
                    </button>
                  </th>
                  <th />
                </tr>
                <tr class="p-table__content__space"><td colspan="5" /></tr>
              </thead>
              <tbody>
                <tr v-for="franchisee in sortedFranchisees" :key="franchisee.id">
                  <td class="u-fwB">{{ franchisee.attributes.name }}</td>
                  <td>
                    <span :class="{'storeCountLink': franchisee.attributes.stores.length}" @click="showStoresModal(franchisee)">
                      {{ $tc('labels.storesCount', franchisee.attributes.stores.length ) }}
                    </span>
                  </td>
                  <td>
                    <div class="flexContainer">
                      <router-link :to="{ name: 'CompaniesFranchiseeEdit', params: { company_uuid: currentCompanyUuid, franchisee_id: franchisee.id }}" class="action">
                        <img :src="imgIconPencil" alt="" class="action__icon">
                        {{ $t('labels.edit') }}
                      </router-link>
                      <a class="action" @click="onClickDeleteFranchisee(franchisee.id, franchisee.attributes.original_tagged)">
                        <img :src="imgIconCross" alt="" class="action__icon">
                        {{ $t('labels.delete') }}
                      </a>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <p v-show="!franchisees || franchisees.length == 0">{{ $t('messages.notRegistered', { value: $t('models.franchisee.modelName') }) }}</p>
        <div class="c-button c-button--right">
          <router-link :to="{ name: 'CompaniesFranchiseeNew', params: { company_uuid: currentCompanyUuid }, query: { currentTab: 'Franchisee' } }" class="c-button__item c-button__item--primary">{{ $t('labels.add', { value: $t('models.franchisee.modelName') }) }}</router-link>
        </div>
      </div>
      <Loading v-show="loading" />
      <KkItemListModal
        :is-visible="openStoresModal"
        :header-label="$t('labels.targetStores')"
        :item-list="stores"
        @close="hideStoresModal"
      />
    </div>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import Loading from '../../../components/Loading'
import ImgIconPencil from '../../../../../images/common/icon_pencil.svg'
import ImgIconCross from '../../../../../images/common/icon_cross.svg'
import Info from '../../../components/Info'
import KkItemListModal from '../../../components/projects/KkItemListModal'

export default {
  name: 'CompaniesManagementFranchisees',
  components: {
    Info,
    Loading,
    KkItemListModal,
  },
  data() {
    return {
      sortOrder: '',
      openStoresModal: false,
      stores: [],
    }
  },
  computed: {
    ...mapState({
      franchisees: state => state.companiesFranchisees.data,
      loading: state => state.companiesFranchisees.loading,
    }),
    sortedFranchisees() {
      const ascFunc = (a, b) => a.attributes.stores.length - b.attributes.stores.length
      const descFunc = (a, b) => b.attributes.stores.length - a.attributes.stores.length
      switch (this.sortOrder) {
      case 'asc':
        return this.franchisees.sort(ascFunc)
      case 'desc':
        return this.franchisees.sort(descFunc)
      default:
        return this.franchisees
      }
    },
    orderCss() {
      if (this.sortOrder === '') return '' // 初期値の場合は CSS なし
      return this.sortOrder === 'asc' ? 'is-asc' : 'is-desc'
    },
    currentCompanyUuid() {
      return this.$route.params.company_uuid
    },
    imgIconPencil: () => ImgIconPencil,
    imgIconCross: () => ImgIconCross
  },
  created() {
    this.readFranchisees(this.currentCompanyUuid)
  },
  methods: {
    ...mapActions({
      readFranchisees: 'companiesFranchisees/readFranchisees',
      deleteFranchisee: 'companiesFranchisees/deleteFranchisee',
    }),
    onClickDeleteFranchisee(franchisee_id, originalTagged) {
      const message = originalTagged ? this.$t('pages.companies.management.franchisees.ConfirmToDelete') : this.$t('messages.confirmToDelete')
      if (confirm(message)) {
        this.deleteFranchisee({ company_uuid: this.currentCompanyUuid, franchisee_id: franchisee_id })
      }
    },
    sort() {
      this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc'
    },
    showStoresModal(franchisee) {
      if (!franchisee.attributes.stores.length) return

      this.stores = franchisee.attributes.stores
      this.openStoresModal = true
    },
    hideStoresModal() {
      this.stores = []
      this.openStoresModal = false
    }
  },
}
</script>
<style lang="scss" scoped>
@import '../../../../../stylesheets/biz_spa/foundation/_var.scss';

.flexContainer {
  display: flex;
  justify-content: flex-end;
}
.action {
  display: flex;
  align-items: flex-start;
  margin-right: 24px;
  font-size: 12px;
  text-decoration: none;
  cursor: pointer;
  &__icon {
    width: 18px;
    margin-right: 8px;
    img {
      display: block;
      width: 100%;
    }
  }
}
.p-table__content tbody th:not(:first-child), .p-table__content tbody td:not(:first-child) {
  border-left: none;
}

.storeCountLink {
  cursor: pointer;
  color: $color-accent-primary;
  text-decoration: underline;
}
</style>
